module.exports = __webpack_public_path__ + "static/media/Brawn.10e63b73.svg";